"use client";

import { useEffect } from "react";
import { claritySetTag } from "./analytics";

/**
 * 在页面挂载时设置 Clarity 页面类型标签。
 * 用法: 各页面组件顶部调用 usePageTag("home"|"celebrity"|"topic"|...)
 */
export function usePageTag(type: string): void {
  useEffect(() => {
    claritySetTag("page_type", type);
  }, [type]);
}
